import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService, PrincipalService, ProfileService } from "app/ppm-app/shared";
import { AccountType } from "app/ppm-app/shared/types/account.type";
import { ROLE_CONSTANTS } from "../../../../shared/constants/constant";

@Component({
  selector: "app2-nav-mobile",
  templateUrl: "./nav-mobile.component.html",
  styleUrls: ["./nav-mobile.component.css"],
})
export class NavMobileComponent implements OnInit {
  @Output() menuState = new EventEmitter<boolean>();
  // role
  isAdmin: boolean = false;
  isEmployee: boolean = false;
  isCustomer: boolean = false;
  account: AccountType;
  serverError: boolean = false;
  authenticatedMenus

  constructor(
    private principal: PrincipalService,
    private loginService: LoginService,
    private router: Router,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    // this.profileService.getAuthenticatedMenus().subscribe((menu) => {
    //   console.log(menu)
    //   this.authenticatedMenus = menu
    // });
    const localMenu = localStorage.getItem('menu');
    const obj = JSON.parse(localMenu)
    this.authenticatedMenus = obj
    
    // check user
    this.principal.identity(true).then(
      (account) => {
        this.account = account;
        this.serverError = false;
        let role = this.account["authorities"][0];
        if (
          role == ROLE_CONSTANTS.ROLE_ADMIN ||
          role == ROLE_CONSTANTS.ROLE_EMPLOYEE ||
          role == ROLE_CONSTANTS.ROLE_SUPPORT
        ) {
          this.isAdmin = true;
        }
        if (role == ROLE_CONSTANTS.ROLE_EMPLOYER) {
          this.isEmployee = true;
        }
        if (this.account == null) {
          this.router.navigate(["login"]);
          this.serverError = true;
        }
      },
      (error) => {
        this.serverError = true;
        this.router.navigate(["login"]);
      }
    );
  }

  closeMenu() {
      this.menuState.emit(false)
  }

  logout() {
    this.menuState.emit(false)
    const timout = false;
    this.account = null;
    this.principal.authenticate(null);
    this.loginService.logout(timout);
  }
}
